import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPie = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#E2E2EB"
      d="M59.481 86.556a97.614 97.614 0 0 0 99.543 136.926l-10.442-97.054z"
    />
    <path
      fill="#EEEEF3"
      d="M158.009 223.533a97.62 97.62 0 0 0 78.749-55.358 97.61 97.61 0 0 0-7.031-96.002l-81.182 54.205z"
    />
    <path
      fill="#C5C6D6"
      d="M95.5 44.52A97.6 97.6 0 0 0 57.77 90.494l90.734 35.999z"
    />
    <path
      fill="#F6F6F9"
      d="M162.701 29.913a97.62 97.62 0 0 0-71.03 17.162l56.774 79.406.016-.096L239.8 92.118a97.61 97.61 0 0 0-77.088-62.273z"
    />
  </svg>
);
export default SvgPie;
